/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import * as $ from 'jquery';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import "./utmtracker";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import 'lite-youtube-embed';

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

const names: Record<string, number> = {};
for (const input of document.querySelectorAll<HTMLInputElement>("input[data-name='prod']")) {
	if (names[input.name] === 1) {
		for (const ele of document.querySelectorAll<HTMLInputElement>(`input[data-name='prod'][name='${input.name}']`)) {
			ele.addEventListener('change', () => {
				for (const e of document.querySelectorAll<HTMLInputElement>(`input[data-name='prod'][name='${input.name}']`)) {
					e.checked = ele.checked;
				}
			});
		}
	}
	names[input.name] = (names[input.name] ?? 0) + 1;
}

//=========================================================
// Adds classes to body as we scroll
//=========================================================
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 40,
	scrollDistanceUp: 20
});
//=========================================================


//===================================================================
// Video - Lightbox
//===================================================================
import VideoLightbox from './component/VideoLightbox';
VideoLightbox();
//===================================================================


//===================================================================
// Plaudit Query Loop Sticky Results
//===================================================================
import './plaudit-query-loop-sticky';
//===================================================================


//===================================================================
// FAQ's
//===================================================================
const availableAccordion = $(".faqs");

if(availableAccordion.length !== 0) {
	// On Page Load - Close all accoridons
	const firstAccordionActive = availableAccordion.find('.faqs__item');
	for (let i = 0; i < firstAccordionActive.length; i++) {
		$(firstAccordionActive[i]).removeClass("active").find(".answer").slideUp(0);
	}

	// Listeners
	$('.faqs__items .question').on( "click" , function( event ) {
		const questionId = $(this).parent().attr('data-question-id');
		availableAccordion.trigger("changeActive", {questionId});
	});

	// Triggers
	// Updates 'Active' Accordion
	availableAccordion.on( "changeActive" , function(event, data) {
		const updateActiveAccordion = availableAccordion.find(".faqs__item");

		for (let i = 0; i < updateActiveAccordion.length; i++) {
			if (data.questionId === updateActiveAccordion[i].dataset.questionId) {
				if ($(updateActiveAccordion[i]).hasClass("active")) {
					$(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
				} else {
					$(updateActiveAccordion[i]).addClass("active").find(".answer").slideDown();
				}
			} else {
				// To have only one accordion open at a time, uncomment the line below.
				// $(updateActiveAccordion[i]).removeClass("active").find(".answer").slideUp();
			}
		}
	});
}
//===================================================================




// Resources and Events filter (for mobile)
//===================================================================
const $html = $("html");
const $body = $("#body");
const $sidebar = $(".plauditQueryLoop__sidebar");
const $filterLink = $(".plauditQueryLoopField__filterLink");
const $footerLink = $(".plauditQueryLoopField__footerLink");

function toggleFilter() {
  if ($filterLink.parent().parent().hasClass("active")) {
    $html.removeClass("noScroll");
    $body.removeClass("filterOpen");
    $filterLink.parent().parent().removeClass("active");
  } else {
    $html.addClass("noScroll");
    $body.addClass("filterOpen");
    $filterLink.parent().parent().addClass("active");
  }
}

$filterLink.on('click', toggleFilter);
$footerLink.on('click', toggleFilter);

$(document).on('mouseup', function(e:any) {
  if (!$sidebar.is(e.target) && $sidebar.has(e.target).length === 0 && $filterLink.parent().parent().hasClass("active")) {
    $html.removeClass("noScroll");
    $body.removeClass("filterOpen");
    $filterLink.parent().parent().removeClass("active");
  }
});
//===================================================================



// Open any links who's href includes "http" in a new tab
//===================================================================
// const links = document.querySelectorAll('a[href*="http"]');
// links.forEach(link => {
//   link.setAttribute('target', '_blank');
// });
//===================================================================



//===================================================================
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
//===================================================================




//===================================================================
// Mega Menu
//===================================================================
const megamenu_contents_url = document.querySelector('#menu').getAttribute('data-megamenu_contents_url');

if (megamenu_contents_url) {
	// Get all post IDs from the mega menu and createa a query string
	const menuLinksWithSubmenu = $('.mega-menu-link[data-oid]:has(+ .mega-sub-menu .custom-html-widget)');
	const queryParameters = menuLinksWithSubmenu.toArray()
		.map(
			item => `${encodeURIComponent($(item).data('type'))}_ids[]=${encodeURIComponent($(item).data('oid'))}`
		).join('&');

	// Fetch the data from the API for the menu items and use template to render the HTML
	fetch( megamenu_contents_url + queryParameters )
		.then(response => response.json())
		.then(data => {
			// We need to populate the mega menu with the data now but we have to ensure window.wp (which is wp-util) is loaded.
			// To ensure it is loaded we wait for the document to be ready.
			const populateMegaMenu = () => {
				const template = (window as any).wp.template('mega-menu-tab-content');

				menuLinksWithSubmenu.each(function() {
					const type = $(this).data('type');
					const oid = $(this).data('oid') as number;
					const myData = data[`${type}_${oid}`];

					// console.log(`Key: ${type} ${oid}`, myData);

					const html = template(myData);

					const htmlWidget = $(this).parent('li').find('.custom-html-widget');
					htmlWidget.html(html);
				});
			};
			if (document.readyState === 'complete') {
				populateMegaMenu();
			} else {
				window.addEventListener('load', populateMegaMenu);
			}
		})
		.catch(error => console.error(error));
}




//===================================================================
// Infographic
//===================================================================
const infographicBuilding = $(".infographic");
// console.log(infographicBuilding);

if (infographicBuilding.length !== 0) {

	// On Page Load
	// --------------------------------------------------------------------------------------------------//
	// When document is ready, updated button (prev/next) text.
	$(document).on("ready", function () {
		const buttons = infographicBuilding.find(".infographic__markerDetail");
	});
	// --------------------------------------------------------------------------------------------------//

	// Listeners
	// --------------------------------------------------------------------------------------------------//
	// If clicked on Building Marker (icon)
	$(".marker").on("click", function (event) {
		const imageId = $(this).attr("data-image-id");
		infographicBuilding.trigger("updateActive", { imageId });
	});

	$(".btn--close").on("click", function (event) {
		const imageId = $(this).attr("data-image-id");
		infographicBuilding.trigger("updateActive", { imageId });
	});

	// Click outside of the active .infographic__markerDetail
	$(document).on("click", function (event) {
		if (
			!$(event.target).closest(".infographic__markerDetail").length &&
			!$(event.target).closest(".marker").length
		) {
			infographicBuilding.find(".active").removeClass("active");
		}
	});
	// --------------------------------------------------------------------------------------------------//

	// Triggers
	// --------------------------------------------------------------------------------------------------//
	// When triggered, this will updated the 'Active' class
	infographicBuilding.on("updateActive", function (event, data: any = null) {
		const updateActiveMarker = infographicBuilding.find(".marker");

		// Add or remove 'active' class for the marker
		for (let i = 0; i < updateActiveMarker.length; i++) {
			if (data.imageId === updateActiveMarker[i].dataset["imageId"]) {
				if ($(updateActiveMarker[i]).hasClass("active")) {
					$(updateActiveMarker[i]).removeClass("active");
				} else {
					$(updateActiveMarker[i]).addClass("active");
				}
			} else {
				$(updateActiveMarker[i]).removeClass("active");
			}
		}

		// Toggle 'active' class for the parent element
		const parentMarker = infographicBuilding
			.find('.marker[data-image-id="' + data.imageId + '"]')
			.parent()
			.parent();
		if (updateActiveMarker.filter(".active").length > 0) {
			parentMarker.addClass("active");
		} else {
			parentMarker.removeClass("active");
		}

		// Add or remove 'active' class for the detail
		const updateActiveDetail = infographicBuilding.find(
			".infographic__markerDetail"
		);
		for (let i = 0; i < updateActiveDetail.length; i++) {
			if (data.imageId === updateActiveDetail[i].dataset["imageId"]) {
				if ($(updateActiveDetail[i]).hasClass("active")) {
					$(updateActiveDetail[i]).removeClass("active");
				} else {
					$(updateActiveDetail[i]).addClass("active");
				}
			} else {
				$(updateActiveDetail[i]).removeClass("active");
			}
		}
	});
}



//========================================================================================================
// Page Headings - checks to see if the .pageHeading--standard has specific elements following it.
//========================================================================================================
// $(document).ready(function() {
// 	var pageHeadings = $('.pageHeading--standard');

// 	pageHeadings.each(function() {
// 		if ($(this).next().hasClass('cardListing') || $(this).next().hasClass('industries')) {
// 		$(this).addClass('hasCards');
// 		}
// 	});
// });
//========================================================================================================



//========================================================================================================
// Site Feedback
//========================================================================================================
window.addEventListener('DOMContentLoaded', function() {
	const siteHtml = document.querySelector('html');
	const siteBody = document.querySelector('body');
	const form_btn = document.querySelector('.siteFeedbackButton');
	const form_close_btn = document.querySelector('.closeBtn');
	const form_wrapper = document.querySelector('.siteFeedbackButton__form');
	const formSubmitBtn = document.querySelector('.siteFeedbackButton__form .gform-button');

	// Function to toggle active classes
	function toggleActiveClasses() {
		siteHtml.classList.toggle('form-is-active');
		siteBody.classList.toggle('form-is-active');
		form_btn.classList.toggle('form-is-active');
		form_wrapper.classList.toggle('form-is-active');
	}

	// Function to handle menu closing
	function closeMenu() {
		if (form_btn.classList.contains('form-is-active')) {
		toggleActiveClasses();
		}
	}

	// Add event listener to menu button
	form_btn.addEventListener('click', function () {
		toggleActiveClasses();
	});

	// Add event listener to close button
	form_close_btn.addEventListener('click', function () {
		toggleActiveClasses();
	});

	// Click outside of the active form_wrapper
	document.addEventListener("click", function (event) {
		if (
		!$(event.target).closest(form_wrapper).length &&
		!$(event.target).closest(form_btn).length
		) {
		closeMenu();
		}
	});

	// Check if menu should be active on page load
	if (localStorage.getItem('menuActive') === 'true') {
		toggleActiveClasses();
	}

	// Closes form after X seconds
	// formSubmitBtn.addEventListener('click', function() {
	//   setTimeout(function() {
	// 	closeMenu();
	//   }, 6000);
	// });
});
